<template>
    <div class="col-sm-8">
        <b-form-input :id="code" :name="code" type="text" v-model="input_text" :placeholder="placeholder" :required="required"></b-form-input>
    </div>
</template>

<script type="text/javascript">
	import Vue from 'vue'
    import Navigation from '@/mixins/Navigation.js'

	export default {
		name: "TextInput",
        mixins: [Navigation],
        props:[
            'placeholder',
            'q_id',
            'answer_given',
            'required',
            'code'
        ],
        data() {
            return {
                input_text: '',
                events_tab: {
                    'inputs::resetChecked': this.resetCheck
                }
            }
        },
        mounted() {
            this.init_component()
        },
        methods: {
            init_component() {
                if(this.answer_given && this.answer_given.val!==null && this.answer_given.key == this.q_id) {
                    this.input_text = this.answer_given.val[0]
                }
            },
            resetCheck() {
                this.input_text = ''
            }
        },
        watch: {
            'input_text' (val) {
                this.$emit('update:answer', { key: this.q_id, val: val })
            }
        }
    }
</script>
